export enum SymbolEvents {
  CREATE = 'symbols:create',
  REMOVE = 'symbols:remove',
  LINK = 'symbols:link',
  UNLINK = 'symbols:unlink',
  CREATE_INSTANCE = 'symbols:create:instance',
  DELETE_INSTANCE = 'symbols:delete:instance',
}
